const value = Object.freeze({
  StatusChange: 1,
  PriorityChange: 2,
});

export const icons = Object.freeze({
  [value.StatusChange]: 'fas fa-exchange-alt',
  [value.PriorityChange]: 'fas fa-list',
});

export const names = Object.freeze({
  [value.StatusChange]: 'Cambio de Estatus',
  [value.PriorityChange]: 'Cambio de Prioridad',
});

export default value;
